// tslint:disable:no-null-keyword
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { actionViewportCenterOn } from "./actionViewport";
var ViewportWorldSpaceDOM = /** @class */ (function (_super) {
    __extends(ViewportWorldSpaceDOM, _super);
    function ViewportWorldSpaceDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.onViewportChange = function (viewport) {
            if (!viewport) {
                _this.setState({
                    viewport: undefined,
                });
                return;
            }
            _this.setState({
                viewport: viewport,
                viewportScale: viewport.scale,
                viewportX: viewport.left,
                viewportY: viewport.top,
            });
        };
        return _this;
    }
    ViewportWorldSpaceDOM.prototype.componentDidMount = function () {
        var viewportChange$ = this.props.viewportChange$;
        this.viewportSub$ = viewportChange$.subscribe(this.onViewportChange);
    };
    ViewportWorldSpaceDOM.prototype.componentWillUnmount = function () {
        this.viewportSub$.unsubscribe();
    };
    ViewportWorldSpaceDOM.prototype.componentDidUpdate = function () {
        var componentDidUpdate = this.props.componentDidUpdate;
        if (componentDidUpdate) {
            componentDidUpdate();
        }
    };
    ViewportWorldSpaceDOM.prototype.render = function () {
        var _a = this.props, children = _a.children, centerOn = _a.centerOn;
        var viewport = this.state.viewport;
        if (!viewport || !children) {
            return null;
        }
        return children(viewport, centerOn);
    };
    return ViewportWorldSpaceDOM;
}(React.PureComponent));
var mapState = function (state) { return ({
    viewportChange$: state.dependencies.viewportChanged$,
}); };
var mapDispatch = function (dispatch) { return ({
    centerOn: function (x, y) { return dispatch(actionViewportCenterOn({ x: x, y: y })); },
}); };
export var ViewportWorldSpace = connect(mapState, mapDispatch)(ViewportWorldSpaceDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/viewport/ViewportWorldSpace.tsx
// module id = 271
// module chunks = 3